import React from "react"

import { getListingRoute } from "~utils/navigation-helpers"
import { useCheckoutFlow } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-provider"
import { findCurrentStepConfigIndex } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-helpers"
import COPY from "~config/copy-constants"
import type { BreadcrumItemType } from "~components/shared/todo-lib-react-components/breadcrumbs"
import Breadcrumbs from "~components/shared/todo-lib-react-components/breadcrumbs"
import type { ListingFieldsFragment } from "~graphql/generated/graphql"

interface Props {
    readonly shouldHideListingLink?: boolean
}

export default function CheckoutFlowBreadcrumbs({
    shouldHideListingLink,
}: Props) {
    const { listing } = useCheckoutFlow()

    const items = useBreadcrumbItems({ shouldHideListingLink, listing })

    // For typescript.
    if (!listing) return null

    return <Breadcrumbs items={items} />
}

function useBreadcrumbItems({
    shouldHideListingLink,
    listing,
}: {
    shouldHideListingLink?: boolean
    listing?: ListingFieldsFragment | null
}): BreadcrumItemType[] {
    const { currentStep, stepConfigs, goToStep } = useCheckoutFlow()
    const currentStepIndex = findCurrentStepConfigIndex({
        currentStep,
        stepConfigs,
    })

    const initialItems: BreadcrumItemType[] = []
    if (!listing) return initialItems

    const listingCrumb = {
        to: getListingRoute(listing.id),
        label: COPY.LISTING,
        isActive: false,
    }
    if (!shouldHideListingLink) {
        initialItems.push(listingCrumb)
    }

    const remainingCrumbs = stepConfigs.map((config, index) => {
        return {
            onClick: () => goToStep({ step: config.step }),
            label: config.label,
            isActive: index === currentStepIndex,
            isDisabled: index > currentStepIndex,
        }
    })

    return [...initialItems, ...remainingCrumbs]
}
